import React from 'react'

import { useSaveTemplate } from './_request/saveTemplate'
import { useTemplate } from './_load/TemplateLoader'
import Editor from './Editor'
import Form from '../../../packages/kiti/components/form/form/Form'
import PageHeader from './PageHeader'

const PageContent = () => {
  const template = useTemplate()
  const [onSubmit, { loading, error }] = useSaveTemplate()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={template}>
      <PageHeader loading={loading} />
      <Editor />
    </Form>
  )
}

export default PageContent
